/*
 * @Descripttion: 中文
 * @version:
 * @Author: AowCt <awoct10@163.com>
 * @Date: 2022-07-19 15:37:56
 * @LastEditors: AowCt <awoct10@163.com>
 * @LastEditTime: 2023-03-02 16:16:07
 */
import headFooter from './headFooter' // 头尾
import frontPage from './frontPage' // 首页
import product from './product' // 核心产品
import scienceResearch from './scienceResearch' // 科研合作
import license from './license' // 详情许可
import job from './job' // 招贤纳士
import news from './news' // 新闻动态
import about from './about' // 公司介绍
import privacyPolicy from './word/privacyPolicy' // 隐私政策
import useClause from './word/useClause' // 使用条款
import guidance from './word/guidance' // 商务合作

const zh = {
  headMenus: headFooter.headMenus,
  footer: headFooter.footer,
  frontPage: frontPage,
  product: product,
  scienceResearch: scienceResearch,
  license: license,
  job: job,
  news: news,
  about: about,
  privacyPolicy: privacyPolicy,
  useClause: useClause,
  guidance: guidance
}
export default zh
